const MONTH = {
    ru: ['Января','Февраля','Марта','Апреля','Мая','Июня','Июля','Августа','Сентября','Октября','Ноября','Декабря'],
    en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
};

export const activityDate2Human = (activityDate, lang, long = true) => {
    const [ date, start, stop ] = activityDate.split(' ');
    const d = new Date(date);
    if(long) {
        return `${d.getDate()} ${MONTH[lang][d.getMonth()]} ${start} - ${stop}`;
    } else {
        return `${d.getDate()} ${MONTH[lang][d.getMonth()]}`;
    }
};
